module.exports = __webpack_public_path__ + "img/UZS.a4fde6ad.svg";